import { render, staticRenderFns } from "./products.select.vue?vue&type=template&id=c9166420"
import script from "./products.select.vue?vue&type=script&lang=js"
export * from "./products.select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports